import { z } from 'zod'
import { parseBoolean } from '@/utils/zod'

/**
 * 提供系統環境變數 Environment Variables
 */
export function useEnv() {
  /** 後端 API */
  const VITE_API_BASE_URL: string | undefined = z
    .string()
    .optional()
    .safeParse(import.meta.env.VITE_API_BASE_URL).data

  /** 前端 DEV 環境 VITE API Proxy 設定 */
  const VITE_API_PROXY_URL: string | undefined = z
    .string()
    .optional()
    .safeParse(import.meta.env.VITE_API_PROXY_URL).data

  /** 前端 前台官網 */
  const VITE_FRONT_URL: string | undefined = z
    .string()
    .optional()
    .safeParse(import.meta.env.VITE_FRONT_URL).data

  /** 前端版本號 */
  const VITE_APPLICATION_VERSION: string | undefined = z
    .string()
    .optional()
    .safeParse(import.meta.env.VITE_APPLICATION_VERSION).data

  /**
   * 前端版本號 - 顯示方式
   *
   * hidden - 隱藏（display: none）
   * visible - 顯示
   * undefined - 不渲染 DOM 元素
   */
  const VITE_APPLICATION_VERSION_MODE: 'hidden' | 'visible' | undefined = z
    .union([z.literal('hidden'), z.literal('visible')])
    .optional()
    .safeParse(import.meta.env.VITE_APPLICATION_VERSION_MODE).data

  /** Base Url */
  const VITE_BASE_URL: string = import.meta.env.BASE_URL.endsWith('/')
    ? import.meta.env.BASE_URL
    : `${import.meta.env.BASE_URL}/`

  const VITE_CONFIG_BASE: string = import.meta.env.VITE_CONFIG_BASE

  /**
   * 是否於 console 顯示 ZOD 錯誤
   * always - 顯示
   * query - 網址列上有 query debug=true 時才顯示
   * never - 不顯示
   */
  const VITE_SHOW_ZOD_ERROR: 'always' | 'query' | 'never' | undefined = z
    .union([z.literal('always'), z.literal('query'), z.literal('never')])
    .optional()
    .safeParse(import.meta.env.VITE_SHOW_ZOD_ERROR).data

  /** 是否顯示 1A 錯誤 */
  const VITE_SHOW_1A_ERROR: boolean | undefined = parseBoolean(
    import.meta.env.VITE_SHOW_1A_ERROR
  )

  /** 是否自動帶入驗證碼 */
  const VITE_AUTO_INPUT_CAPTCHA_CODE: boolean | undefined = parseBoolean(
    import.meta.env.VITE_AUTO_INPUT_CAPTCHA_CODE
  )

  /** 儲存在瀏覽器的資料 Key 前綴 */
  const VITE_STORAGE_PREFIX_KEY: string | undefined = z
    .string()
    .optional()
    .safeParse(import.meta.env.VITE_STORAGE_PREFIX_KEY).data

  /** 是否為測試環境 */
  const VITE_DEV: boolean | undefined = parseBoolean(import.meta.env.VITE_DEV)

  return {
    VITE_API_BASE_URL,
    VITE_API_PROXY_URL,
    VITE_FRONT_URL,
    VITE_APPLICATION_VERSION,
    VITE_APPLICATION_VERSION_MODE,
    VITE_DEV,
    VITE_SHOW_ZOD_ERROR,
    VITE_SHOW_1A_ERROR,
    VITE_BASE_URL,
    VITE_CONFIG_BASE,
    VITE_AUTO_INPUT_CAPTCHA_CODE,
    VITE_STORAGE_PREFIX_KEY
  }
}
